<template>
  <div class="auth-page">
    <nav-header></nav-header>
    
    <div class="page-container">
      <!-- 背景装饰 -->
      <div class="background-decoration">
        <div class="decoration-circle circle-1"></div>
        <div class="decoration-circle circle-2"></div>
        <div class="decoration-circle circle-3"></div>
      </div>

      <div class="auth-container">
        <!-- 主卡片 -->
        <div class="auth-card">
          <!-- 左侧品牌展示区 -->
          <div class="brand-section">
            <div class="brand-content">
           
              <h1 class="brand-title">北京质子游戏科技有限公司</h1>
              <div class="brand-features">
                <div class="feature-item">
                  <i class="feature-icon icon-secure"></i>
                  <span>安全可靠</span>
                </div>
                <div class="feature-item">
                  <i class="feature-icon icon-service"></i>
                  <span>专业服务</span>
                </div>
                <div class="feature-item">
                  <i class="feature-icon icon-support"></i>
                  <span>全面支持</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 右侧表单区 -->
          <div class="form-section">
            <!-- 选项卡导航 -->
            <div class="tab-navigation">
              <div 
                class="tab-item" 
                :class="{ active: cur === 0 }"
                @click="cur = 0"
              >
                <i class="tab-icon icon-login"></i>
                <span>账号登录</span>
              </div>
              <div 
                class="tab-item" 
                :class="{ active: cur === 1 }"
                @click="cur = 1"
              >
                <i class="tab-icon icon-register"></i>
                <span>账号注册</span>
              </div>
            </div>

            <!-- 登录表单 -->
            <div v-show="cur === 0" class="form-content">
              <div class="form-group">
                <div class="input-wrapper">
                  <i class="input-icon icon-user"></i>
                  <input 
                    type="text" 
                    placeholder="请输入用户名" 
                    v-model="lUsername"
                    class="form-input"
                  >
                </div>
              </div>

              <div class="form-group">
                <div class="input-wrapper">
                  <i class="input-icon icon-password"></i>
                  <input 
                    type="password" 
                    placeholder="请输入密码" 
                    v-model="lPassword"
                    class="form-input"
                  >
                </div>
              </div>

            
              <button class="submit-btn primary" @click="logo">
                <i class="btn-icon"></i>
                立即登录
              </button>

             
            </div>

            <!-- 注册表单 -->
            <div v-show="cur === 1" class="form-content register-form">
              <div class="form-row">
                <div class="form-group half">
                  <div class="input-wrapper">
                    <i class="input-icon icon-user"></i>
                    <input 
                      type="text" 
                      placeholder="用户名" 
                      v-model="rUsername"
                      class="form-input"
                    >
                  </div>
                </div>
                <div class="form-group half">
                  <div class="input-wrapper">
                    <i class="input-icon icon-password"></i>
                    <input 
                      type="password" 
                      placeholder="密码" 
                      v-model="rPassword"
                      class="form-input"
                    >
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="input-wrapper">
                  <i class="input-icon icon-email"></i>
                  <input type="text" placeholder="邮箱" class="form-input">
                </div>
              </div>

              <div class="form-row">
                <div class="form-group half">
                  <div class="input-wrapper">
                    <i class="input-icon icon-phone"></i>
                    <input type="text" placeholder="手机号" class="form-input">
                  </div>
                </div>
                <div class="form-group half">
                  <div class="input-wrapper">
                    <i class="input-icon icon-person"></i>
                    <input type="text" placeholder="真实姓名" class="form-input">
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="input-wrapper">
                  <i class="input-icon icon-idcard"></i>
                  <input type="text" placeholder="身份证号" class="form-input">
                </div>
              </div>

              <div class="form-options register-options">
                <label class="checkbox-wrapper">
                  <input type="checkbox" class="checkbox-input">
                  <span class="checkbox-label">我已阅读并同意</span>
                </label>
                <a href="javascript:;" class="agreement-link" @click="goAg">《用户协议》</a>
              </div>

              <button class="submit-btn secondary" @click="register">
                <i class="btn-icon"></i>
                立即注册
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <nav-footer></nav-footer>
  </div>
</template>

<script>
import NavFooter from "./../components/NavFooter";
import NavHeader from "./../components/NavHeader";
export default {
  data() {
    return {
      cur: 0,
      lUsername: "",
      lPassword: "",
      k: this.$route.query.k,
      logo_user: JSON.parse(window.localStorage.getItem("user")),
      href: "index.html",
      rUsername: "",
      rPassword: "",
    };
  },
  components: {
    NavFooter,
    NavHeader,
  },
  mounted() {
    document.title = "北京质子游戏科技有限公司";
  },
  methods: {
    logo() {
      if (this.k) {
        window.localStorage.setItem("state", "0");
        this.$router.push("/");
        window.location.reload();
      } else if (this.lUsername !== this.logo_user.Username) {
        alert("用户名错误");
      } else if (this.lPassword !== this.logo_user.Password) {
        alert("密码错误");
      } else {
        window.localStorage.setItem("state", "0");
        this.$router.push("/index");
        window.location.reload();
      }
    },
    goReg() {
      this.$router.push("/register");
    },
    register() {
      var ruser = {
        Username: this.rUsername,
        Password: this.rPassword,
      };
      if (!this.rUsername) {
        alert("请输入用户名");
        return;
      }
      if (!this.rPassword) {
        alert("请输入密码");
        return;
      }
      window.localStorage.setItem("state", "0");
      window.localStorage.setItem("user", JSON.stringify(ruser));
      this.$router.push("/#/index");
    },
    goAg() {
      this.$router.push("/xy");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.auth-page {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4eaf6 100%);
  box-sizing: border-box;
  padding-top: 80px;

  .page-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 40px 20px;
    position: relative;
  }

  .background-decoration {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;

    .decoration-circle {
      position: absolute;
      border-radius: 50%;
      background: linear-gradient(135deg, rgba(30, 60, 114, 0.1), rgba(255, 107, 53, 0.1));
      
      &.circle-1 {
        width: 200px;
        height: 200px;
        top: 10%;
        left: 5%;
      }
      
      &.circle-2 {
        width: 150px;
        height: 150px;
        bottom: 20%;
        right: 10%;
      }
      
      &.circle-3 {
        width: 100px;
        height: 100px;
        top: 50%;
        left: 80%;
      }
    }
  }

  .auth-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 70vh;
  }

  .auth-card {
    display: flex;
    width: 900px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 20px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.8);
    overflow: hidden;
  }

  .brand-section {
    flex: 1;
    background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
    padding: 60px 40px;
    color: white;
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: -50%;
      right: -50%;
      width: 100%;
      height: 200%;
      background: rgba(255, 255, 255, 0.1);
      transform: rotate(45deg);
    }

    .brand-content {
      position: relative;
      z-index: 1;
      text-align: center;
    }

    .brand-logo {
      width: 80px;
      height: 80px;
      background: linear-gradient(135deg, #ff6b35, #ff8e35);
      border-radius: 20px;
      margin: 0 auto 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);

      .logo-icon {
        width: 40px;
        height: 40px;
        background: white;
        border-radius: 8px;
        position: relative;

        &::before {
          content: "英";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #1e3c72;
          font-size: 20px;
          font-weight: bold;
        }
      }
    }

    .brand-title {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 10px;
      color: #ffd700;
    }

    .brand-subtitle {
      font-size: 16px;
      opacity: 0.9;
      margin-bottom: 40px;
    }

    .brand-features {
      .feature-item {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        font-size: 14px;

        .feature-icon {
          width: 24px;
          height: 24px;
          margin-right: 10px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          position: relative;

          &::before {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white;
            font-size: 12px;
          }
        }

        .icon-secure::before { content: "🔒"; }
        .icon-service::before { content: "💼"; }
        .icon-support::before { content: "🛠️"; }
      }
    }
  }

  .form-section {
    flex: 1.2;
    padding: 50px 40px;
  }

  .tab-navigation {
    display: flex;
    margin-bottom: 40px;
    border-bottom: 1px solid #e0e0e0;

    .tab-item {
      flex: 1;
      text-align: center;
      padding: 15px 0;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      &:not(.active) {
        color: #666;
        
        &:hover {
          color: #1e3c72;
        }
      }

      &.active {
        color: #1e3c72;
        font-weight: bold;

        &::after {
          content: "";
          position: absolute;
          bottom: -1px;
          left: 0;
          width: 100%;
          height: 3px;
          background: linear-gradient(90deg, #1e3c72, #ff6b35);
          border-radius: 2px;
        }
      }

      .tab-icon {
        width: 20px;
        height: 20px;
        position: relative;

        &::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 16px;
        }
      }

      .icon-login::before { content: "🔐"; }
      .icon-register::before { content: "📝"; }
    }
  }

  .form-content {
    .form-row {
      display: flex;
      gap: 20px;

      .form-group.half {
        flex: 1;
      }
    }

    .form-group {
      margin-bottom: 25px;
    }

    .input-wrapper {
      position: relative;
      display: flex;
      align-items: center;

      .input-icon {
        position: absolute;
        left: 15px;
        width: 20px;
        height: 20px;
        z-index: 2;

        &::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #666;
          font-size: 16px;
        }
      }

      .icon-user::before { content: "👤"; }
      .icon-password::before { content: "🔑"; }
      .icon-email::before { content: "📧"; }
      .icon-phone::before { content: "📱"; }
      .icon-person::before { content: "👨"; }
      .icon-idcard::before { content: "🆔"; }

      .form-input {
        width: 100%;
        height: 50px;
        padding: 0 15px 0 45px;
        border: 2px solid #e0e0e0;
        border-radius: 10px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: white;

        &:focus {
          border-color: #1e3c72;
          box-shadow: 0 0 0 3px rgba(30, 60, 114, 0.1);
          outline: none;
        }

        &::placeholder {
          color: #999;
        }
      }
    }
  }

  .form-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;

    &.register-options {
      justify-content: flex-start;
      gap: 5px;
    }

    .checkbox-wrapper {
      display: flex;
      align-items: center;
      cursor: pointer;

      .checkbox-input {
        margin-right: 8px;
      }

      .checkbox-label {
        font-size: 14px;
        color: #666;
      }
    }

    .forgot-link,
    .agreement-link {
      font-size: 14px;
      color: #1e3c72;
      text-decoration: none;
      transition: color 0.3s ease;

      &:hover {
        color: #ff6b35;
        text-decoration: underline;
      }
    }
  }

  .submit-btn {
    width: 100%;
    height: 50px;
    border: none;
    border-radius: 10px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 0;
      height: 0;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      transition: all 0.5s ease;
    }

    &:hover::before {
      width: 300px;
      height: 300px;
    }

    .btn-icon {
      width: 20px;
      height: 20px;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 16px;
      }
    }

    &.primary {
      background: linear-gradient(135deg, #1e3c72, #2a5298);
      color: white;

      .btn-icon::before { content: "→"; }
    }

    &.secondary {
      background: linear-gradient(135deg, #ff6b35, #ff8e35);
      color: white;

      .btn-icon::before { content: "✓"; }
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    }
  }

  .divider {
    text-align: center;
    margin: 30px 0;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      height: 1px;
      background: #e0e0e0;
    }

    span {
      background: white;
      padding: 0 15px;
      color: #666;
      font-size: 14px;
      position: relative;
    }
  }

  .social-login {
    display: flex;
    justify-content: center;
    gap: 20px;

    .social-btn {
      width: 50px;
      height: 50px;
      border: 2px solid #e0e0e0;
      border-radius: 50%;
      background: white;
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;

      .social-icon {
        width: 24px;
        height: 24px;
        position: relative;

        &::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 20px;
        }
      }

      &.wechat .social-icon::before { content: "💬"; }
      &.qq .social-icon::before { content: "🐧"; }
      &.phone .social-icon::before { content: "📞"; }

      &:hover {
        border-color: #1e3c72;
        transform: translateY(-2px);
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      }
    }
  }

  .register-form {
    .form-group {
      margin-bottom: 20px;
    }
  }
}
</style>